import React, { Children } from 'react';

import s from './DescriptiveList.scss';
import { DescriptiveListItem } from './DescriptiveListItem';
import { Container } from 'components/container/Container';

interface IProps {
  title?: string;
  children: React.ReactNode;
  image?: React.ReactElement;
  isColumnLayout?: boolean;
}

export const DescriptiveList = ({ title, children, image, isColumnLayout }: IProps) => {
  const count = Children.count(children);
  const childArray = Children.toArray(children);

  const split = Math.round(count / 2);

  const colA = count > 3 ? childArray.slice(0, split) : childArray;
  const colB = count > 3 ? childArray.slice(split, count) : null;

  const Wrapper = isColumnLayout ? 'div' : Container;

  return (
    <div className={s('descriptiveList', { offset: !isColumnLayout, columns: count > 3 })}>
      <div className={s.descriptiveList__row}>
        {image && <div className={s.descriptiveList__image}>{image}</div>}
        {title && <h2 className={s.descriptiveList__heading}>{title}</h2>}
        <dl className={s.descriptiveList__content}>{colA}</dl>
        {colB && <dl className={s.descriptiveList__content}>{colB}</dl>}
      </div>
    </div>
  );
};
